var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"caseProjectPicDiv",style:({width:this.caseProjectPicSize.width+'%', height:this.caseProjectPicSize.height+'%'})},[_c('p',{staticClass:"textTitle"},[_vm._v(_vm._s(_vm.picItem.title))]),_c('img',{attrs:{"src":_vm.picItem.pic,"alt":_vm.picItem.title1}})])
}
var staticRenderFns = []

export { render, staticRenderFns }